import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { BackwardCompatibilityRedirects } from '@/utils/constants';
import { useEffect } from 'react';

const CompatibilityRedirects = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathName = location.pathname;

  const hasRedirect = BackwardCompatibilityRedirects.hasOwnProperty(currentPathName);

  useEffect(() => {
    if (BackwardCompatibilityRedirects.hasOwnProperty(currentPathName)) {
      const redirect = BackwardCompatibilityRedirects[currentPathName];
      navigate(redirect, { replace: true });
    }
  }, [currentPathName, navigate]);

  if (hasRedirect) {
    return null;
  }

  return <Outlet />;
};

export default CompatibilityRedirects;
